import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <span aria-hidden="true">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      viewBox="0 30 1037.4 60"
      y="0px"
      x="0px"
      width={212}
      height={18}
      className={className}
    >
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#ED1C24"
                    d="M78.59,92.64V56.58L61.7,94L44.81,56.58v36.06H30.75V38.1h19.54l11.45,27.02L73.11,38.1h19.55v54.54
							H78.59z"
                  />
                  <path
                    fill="#ED1C24"
                    d="M139.33,92.64l-2.7-7.85h-21.51l-2.7,7.85H96.48l20.52-54.54h17.75l20.52,54.54H139.33z M125.92,52
							l-6.95,20.52h13.82L125.92,52z"
                  />
                  <path
                    fill="#ED1C24"
                    d="M156.24,84.96L163.68,74c3.93,3.92,9.97,7.2,17.5,7.2c4.74,0,7.69-1.64,7.69-4.33
							c0-7.2-30.83-1.23-30.83-22.24c0-9.16,7.69-17.34,21.67-17.34c8.75,0,16.35,2.62,22.16,7.61l-7.69,10.55
							c-4.58-3.84-10.55-5.73-15.95-5.73c-4.09,0-5.89,1.39-5.89,3.76c0,6.71,30.83,1.64,30.83,21.91
							c0,10.96-8.09,18.24-22.73,18.24C169.41,93.63,161.72,90.11,156.24,84.96z"
                  />
                  <path
                    fill="#ED1C24"
                    d="M207.18,65.41c0-16.6,12.51-28.21,29.19-28.21c16.68,0,29.11,11.61,29.11,28.21
							c0,16.6-12.43,28.21-29.11,28.21C219.7,93.63,207.18,82.01,207.18,65.41z M251.18,65.41c0-8.92-5.81-15.78-14.8-15.78
							c-9,0-14.88,6.87-14.88,15.78c0,8.83,5.88,15.78,14.88,15.78C245.37,81.2,251.18,74.24,251.18,65.41z"
                  />
                  <path
                    fill="#ED1C24"
                    d="M307.85,92.64l-23.06-31.56v31.56h-14.06V38.1h14.47l22.08,30.01V38.1h14.15v54.54H307.85z"
                  />
                </g>
              </g>
            </g>
            <g>
              <g>
                <path
                  fill="#ED1C24"
                  d="M350.94,92.77V37.81h40.3v12.36h-26.12v8.57h25.55V71.1h-25.55v9.31h26.12v12.36H350.94z"
                />
                <path
                  fill="#ED1C24"
                  d="M440.53,92.77l-2.72-7.91h-21.67l-2.72,7.91h-16.07l20.68-54.97h17.88l20.68,54.97H440.53z M427.01,51.82
						l-7,20.68h13.93L427.01,51.82z"
                />
                <path
                  fill="#ED1C24"
                  d="M458.34,85.03l7.5-11.04c3.95,3.96,10.05,7.25,17.63,7.25c4.78,0,7.75-1.65,7.75-4.37
						c0-7.25-31.07-1.24-31.07-22.41c0-9.23,7.74-17.47,21.84-17.47c8.82,0,16.48,2.63,22.33,7.66l-7.75,10.63
						c-4.61-3.87-10.63-5.77-16.07-5.77c-4.12,0-5.94,1.4-5.94,3.79c0,6.76,31.07,1.65,31.07,22.09c0,11.04-8.16,18.38-22.91,18.38
						C471.6,93.76,463.86,90.22,458.34,85.03z"
                />
                <path
                  fill="#ED1C24"
                  d="M525.08,92.77V70.6l-20.85-32.8h15.99l11.95,20.27l11.78-20.27h16.07l-20.77,32.8v22.17H525.08z"
                />
                <path
                  fill="#ED1C24"
                  d="M574.68,92.77V37.81h27.52c12.36,0,19.12,8.32,19.12,18.3c0,9.89-6.76,18.21-19.12,18.21h-13.35v18.46
						H574.68z M606.9,56.1c0-3.79-3.05-5.94-6.84-5.94h-11.21v11.78h11.21C603.86,61.95,606.9,59.81,606.9,56.1z"
                />
                <path
                  fill="#ED1C24"
                  d="M659.48,92.77l-2.72-7.91h-21.67l-2.72,7.91H616.3l20.68-54.97h17.89l20.68,54.97H659.48z M645.97,51.82
						l-7.01,20.68h13.93L645.97,51.82z"
                />
                <path
                  fill="#ED1C24"
                  d="M685.18,92.77V70.6l-20.85-32.8h15.99l11.95,20.27l11.78-20.27h16.07l-20.77,32.8v22.17H685.18z"
                />
              </g>
              <path
                fill="#ED1C24"
                d="M566.38,73.86c0-4.64-3.77-8.41-8.41-8.41c-4.65,0-8.41,3.77-8.41,8.41c0,4.65,3.76,8.42,8.41,8.42
					C562.62,82.27,566.38,78.5,566.38,73.86z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M785.2,53.53c-1.51-4.72-4.77-8.05-9.92-8.05c-6.97,0-11.21,6.66-11.21,19.74c-0.15,13.08,3.64,19.74,11.52,19.74
			c4.7,0,7.58-1.7,10.68-8.28l9.7,2.63c-3.26,9.68-10.38,14.63-20.38,14.63c-13.94,0-21.97-10.45-21.97-28.72
			s8.03-28.72,21.97-28.72c10.46,0,16.52,4.8,19.09,14.71L785.2,53.53z"
          />
          <path
            d="M803.54,93.17v-55.9h21.82c12.42,0,17.42,7.35,17.5,16.57c0.08,6.89-3.33,12.47-10,14.4l12.05,24.93h-11.59l-10.3-22.76
			h-9.02v22.76H803.54z M813.99,61.73h7.73c8.18,0,10.68-2.63,10.68-7.9s-3.11-7.9-8.86-7.9h-9.55V61.73z"
          />
          <path d="M854.52,93.17v-55.9h36.21v8.98h-25.76v13.32h18.71v8.98h-18.71v15.64h26.59v8.98H854.52z" />
          <path
            d="M900.36,37.27h18.11c14.47,0,24.47,8.21,24.55,27.95c-0.08,19.74-10.08,27.95-24.55,27.95h-18.11V37.27z M910.81,84.19
			h6.97c11.97,0,14.77-8.98,14.77-18.97s-2.8-18.97-14.77-18.97h-6.97V84.19z"
          />
          <path d="M952.33,93.17v-55.9h10.46v55.9H952.33z" />
          <path d="M1010.82,37.19v8.98H996.5v47h-10.46v-47h-14.32v-8.98H1010.82z" />
        </g>
        <g>
          <path
            fill="#ED1C24"
            d="M731.73,37.4c3.78,0,7.02,2.94,7.02,6.92c0,4.02-3.24,6.96-7.02,6.96c-3.82,0-7.05-2.94-7.05-6.96
			C724.68,40.33,727.92,37.4,731.73,37.4z M731.73,38.52c-3.22,0-5.71,2.49-5.71,5.8c0,3.39,2.49,5.84,5.71,5.84
			c3.18,0,5.67-2.45,5.67-5.84C737.4,41.01,734.91,38.52,731.73,38.52z M730.25,48.34h-1.23v-8.01h3.07c1.91,0,2.84,0.71,2.84,2.28
			c0,1.44-0.9,2.06-2.1,2.21l2.28,3.52h-1.35l-2.13-3.48h-1.38V48.34z M730.25,43.85h1.46c1.5,0,1.98-0.43,1.98-1.31
			c0-0.77-0.37-1.2-1.78-1.2h-1.67V43.85z"
          />
        </g>
      </g>
    </svg>
  </span>
);

export default Icon;
